// Lê QR de um <video> ao vivo. Usa o detector nativo do navegador quando existe
// (Android/Chrome: rápido e sem baixar nada) e cai pro jsQR no resto (iPhone,
// Windows/Electron do caixa), carregado só na primeira leitura.

let jsQR = null;

async function carregarJsQR() {
  if (!jsQR) {
    const mod = await import("./jsQR");
    jsQR = mod.default || mod;
  }
  return jsQR;
}

export async function criarLeitor() {
  if (typeof window !== "undefined" && "BarcodeDetector" in window) {
    try {
      const formatos = await window.BarcodeDetector.getSupportedFormats();
      if (formatos.includes("qr_code")) {
        const detector = new window.BarcodeDetector({ formats: ["qr_code"] });
        return async (video) => {
          const achados = await detector.detect(video);
          return achados[0]?.rawValue || null;
        };
      }
    } catch {
      /* cai pro jsQR */
    }
  }
  const decodificar = await carregarJsQR();
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d", { willReadFrequently: true });
  return async (video) => {
    const w = video.videoWidth;
    const h = video.videoHeight;
    if (!w || !h) return null;
    // Reduz pra ~640px no maior lado: jsQR fica rápido e o QR continua legível.
    const escala = Math.min(1, 640 / Math.max(w, h));
    canvas.width = Math.round(w * escala);
    canvas.height = Math.round(h * escala);
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    const img = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const achado = decodificar(img.data, canvas.width, canvas.height, { inversionAttempts: "dontInvert" });
    return achado?.data || null;
  };
}
